export const SCAN_CATEGORY_ICONS: Record<string, string> = {
  'Muscles & Joints': 'muscles-joints-icon.webp',
  Male: 'male-icon.webp',
  Female: 'female-icon.webp',
  Abdominal: 'abdominal-icon.webp',
};

export const DEFAULT_SCAN_CATEGORY_ICON = 'muscles-joints-icon.webp';

export const getScanCategoryIcon = (label: string): string =>
  SCAN_CATEGORY_ICONS[label] ?? DEFAULT_SCAN_CATEGORY_ICON;
